import { useEffect, useState } from 'react';
import { getInterestedUser } from '../services/registration-service';
import { useQuery } from './useQuery';
import { useClubContext } from '../context/ClubContext';
import { ApiResponse, ApiStatus } from '../models/api-response';
import { useConfigContext } from '../context/ConfigContext';
import { useLabelsContext } from '../context/LabelsContext';
import { InterestedUser } from '../models/interested-user';

export function useInterestedUser() {
    const { config } = useConfigContext();
    const { club } = useClubContext();
    const { labels } = useLabelsContext();
    const [interestedUser, setInterestedUser] = useState<InterestedUser | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const query = useQuery();
    const guestId: string | null = query.get("guestid") || null;

    useEffect(() => {
        if (!config || !guestId || !club) return;
        setIsLoading(true);
        getInterestedUser(
            config,
            Number(guestId),
            false,
            club?.bookingDomain
        ).then((response: ApiResponse<InterestedUser>) => {
            if (response.Status === ApiStatus.Success && response.Data) {
                setInterestedUser(
                    {
                        ...response.Data,
                        verified: false
                    }
                );
                return;
            }
            if (response.Status === ApiStatus.Error && response?.Errors?.length) {
                const errorMessage = response?.Errors[0]?.Message || labels?.["ApiErrorsLabels4"] || "Unknown error";
                setError(errorMessage);
            }
        })
            .catch((e) => setError(e.message))
            .finally(() => setTimeout(() => { setIsLoading(false) }, 0));
    }, [config, club]);

    return { interestedUser, setInterestedUser, isLoading, error };
}
